export function mapAdditionalLeaderboardApiToRows(response) {
    var _a;
    return ((_a = response.rows) !== null && _a !== void 0 ? _a : []).map((r) => ({
        salesAgentId: r.salesAgentId,
        salesAgentName: r.salesAgentName,
        tiUitbreidingInOfferte: r.tiUitbreidingInOfferte,
        tiUitbreidingGewonnen: r.tiUitbreidingGewonnen,
        tiUitbreidingOmzet: r.tiUitbreidingOmzet,
        tiMeerwerkOffertesGewonnen: r.tiMeerwerkOffertesGewonnen,
        tiMeerwerkInkomsten: r.tiMeerwerkInkomsten,
        ppeOffertesGewonnen: r.ppeOffertesGewonnen,
        ppeInkomsten: r.ppeInkomsten,
        inkomstenEfficyTotaal: r.inkomstenEfficyTotaal,
    }));
}
